import React from "react";
import { motion } from "framer-motion";
import { Section } from "./Section";
import { skills } from "../../data/portfolio";

export const Skills = () => {
  return (
    <Section
      id="skills"
      label="Toolkit"
      title="A pragmatic stack. No flags planted, no tribal loyalty."
      index={5}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-900 border border-neutral-900">
        {skills.map((group, i) => (
          <motion.div
            key={group.group}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.06 }}
            data-testid={`skills-group-${group.group.toLowerCase().replace(/\s+/g, "-")}`}
            className="bg-[#0a0a0a] p-8 md:p-10 flex flex-col gap-6 min-h-[260px]"
          >
            <div className="flex items-baseline justify-between">
              <h3 className="font-serif text-xl md:text-2xl text-neutral-100">
                {group.group}
              </h3>
              <span className="text-mono-label">
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              {group.items.map((s) => (
                <span
                  key={s}
                  className="border border-neutral-800 hover:border-neutral-600 transition-colors px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider text-neutral-300"
                >
                  {s}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default Skills;
